var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"title"},[_c('v-icon',{staticClass:"fa-fw fa-pulse"},[_vm._v("fa-spinner")]),(this.$slots.default)?[_vm._t("default")]:_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }